import { keysToSnake } from '#/api/adapters/wireCase';

function emptyToNull(value) {
  if (value == null) {
    return null;
  }
  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
}

function mapRepairItemIds(values) {
  const raw = values?.repairItemIds ?? values?.repair_item_ids ?? [];
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw
    .map((id) => emptyToNull(id))
    .filter(Boolean);
}

/**
 * Create：signReceiptNo＋repairItemIds（必填）＋選填 customerId／header 快照。
 * 禁送 reservationId／repairReportId／serialNo／status／lines 快照。
 */
export function toSignReceiptCreateBody(values = {}) {
  const customerId = emptyToNull(values.customerId);
  return {
    ...(customerId ? { customerId } : {}),
    signReceiptNo: emptyToNull(values.signReceiptNo),
    signReceiptDate: emptyToNull(values.signReceiptDate),
    customerName: emptyToNull(values.customerName),
    contactName: emptyToNull(values.contactName),
    phone: emptyToNull(values.phone),
    fax: emptyToNull(values.fax),
    taxId: emptyToNull(values.taxId),
    address: emptyToNull(values.address),
    remark: emptyToNull(values.remark),
    repairItemIds: mapRepairItemIds(values),
  };
}

/**
 * PATCH：header 快照與／或 repairItemIds（出現＝整表取代）＋updatedAt。
 * `customerId`：省略＝保留既有關聯；明示 null＝清除。
 * 禁送 signReceiptNo／status／record／history／serialNo／repairReportId。
 */
export function toSignReceiptUpdateBody(values = {}) {
  const updatedAt = values.updatedAt ?? values.record?.updatedAt ?? null;
  const payload = {};

  const headerKeys = [
    'signReceiptDate',
    'customerId',
    'customerName',
    'contactName',
    'phone',
    'fax',
    'taxId',
    'address',
    'remark',
  ];
  for (const key of headerKeys) {
    if (Object.prototype.hasOwnProperty.call(values, key)) {
      payload[key] = emptyToNull(values[key]);
    }
  }
  if (Object.prototype.hasOwnProperty.call(values, 'repairItemIds')
    || Object.prototype.hasOwnProperty.call(values, 'repair_item_ids')) {
    payload.repairItemIds = mapRepairItemIds(values);
  }
  if (updatedAt != null && updatedAt !== '') {
    payload.updatedAt = updatedAt;
  }

  return payload;
}

/** establish／complete／cancel：body 僅 `{ updatedAt }` */
export function toSignReceiptCommandBody(payload = {}) {
  const updatedAt = payload.updatedAt ?? payload.record?.updatedAt ?? null;
  const body = {};
  if (updatedAt != null && updatedAt !== '') {
    body.updatedAt = updatedAt;
  }
  return body;
}

export function serializeSignReceiptCreate(values) {
  return keysToSnake(toSignReceiptCreateBody(values));
}

export function serializeSignReceiptUpdate(values) {
  return keysToSnake(toSignReceiptUpdateBody(values));
}

export function serializeSignReceiptCommand(payload) {
  return keysToSnake(toSignReceiptCommandBody(payload));
}
